// services/partnersService.ts
import api from '../lib/api';

const API_URL = import.meta.env.VITE_API_URL;

export async function fetchPartners() {
  try {
    const res = await api.get(`${API_URL}/api/partners`);

    if (Array.isArray(res.data)) return res.data;

    console.error('Unexpected partner API response:', res.data);
    return [];
  } catch (err) {
    console.error('Error loading partners:', err);
    return [];
  }
}
